import { ProductsTable } from "@/components/tables/products";
import { buildMetadata } from "@/lib/metadata";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { data } from "./-data/productData";
export const Route = createFileRoute("/_main/products/")({
  component: RouteComponent,
  loader: async () => {
    return {
      data,
    };
  },
  head: () => ({
    meta: buildMetadata({
      title: "Products",
      description: "View all products",
      keywords: ["products", "product", "view"],
    }),
  }),
});

function RouteComponent() {
  const tableData = Route.useLoaderData();
  const router = useRouter();

  router.navigate({ to: "/orders" });

  return (
    <div className="p-8">
      <ProductsTable data={tableData.data} />
    </div>
  );
}
